export var localeDropDownWrapper = 'flex items-stretch py-2';
export var contentWrapper = 'fixed top-0 w-full h-full flex-col bg-uiBg z-10';
export var bannerContentWrapper = 'flex flex-col justify-between items-stretch';
export var articleText = 'py-4 px-4 text-textDark';
export var bottom = 'pt-4 px-4';
export var closeButton = 'mt-4 mb-4 w-full';
export var languageLabel = 'font-medium flex items-center justify-start font-body text-textDark pr-2 mt-1';
//# sourceMappingURL=language-selector.styles.js.map